var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.passwordForgotUrl || _vm.registerUrl)?_c('div',{staticClass:"d-flex justify-content-between"},[(_vm.passwordForgotUrl)?_c('b-button',{attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.$store.commit('ping/setView', 'FORGOT_PASSWORD')}}},[_vm._v(" Forgot Password ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }